<template>
  <div class="mode3">
    <div class="explain-box">
      <p class="explain-item">1.使用本功能钱前需要在淘宝服务市场订购服务放可使用<a href="javascript:void(0);">《淘宝/天猫订单下单教程》</a> <a
          href="javascript:void(0);">《拼多多订单号下单教程》</a></p>
      <p class="explain-item">2.订购服务之后需要授权店铺，在授权店铺有效期内方可使用本功能。</p>
      <p class="explain-item">3.输入店铺的待发货订单或者选择代发订单，点击同步即可24小时内发货订单同步过来。</p>
      <p class="explain-item">4.如果需要从大量订单里面筛选，建议先在店铺打旗之后，再点击同步。</p>
      <p class="explain-item">5.如果自动发货出单号5分钟后，后台没有自动发货的话，可以在订单列表点击一下发货。</p>
    </div>

    <div class="build-shop">
      <div class="build-form-item">
        <div class="build-form-item-content">
          <span class="build-form-key">选择店铺</span>
          <el-select v-model="order_param.shop_id" filterable style="width: 300px;" @change="onSelectShop">
            <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="'【'+item.type+'】'+item.shop_name"
                :value="item.shop_id"/>
          </el-select>
        </div>
        <div class="shop-button">
          <a href="javascript:void(0)" class="btn btn_1" @click="addBuildShop">添加店铺</a>
          <!--          <a href="javascript:void(0)" class="btn btn_2">订购服务</a>-->
          <a href="javascript:void(0)" class="btn btn_2" @click="loadShopData">刷新</a>
          <a href="javascript:void(0)" class="btn btn_2" @click="onDeleteShop">删除</a>
        </div>

      </div>
      <div class="build-form-item">
        <span class="build-form-key">订单状态</span>
        <el-select v-model="order_param.status" style="width: 300px;" @change="onSelectFilter">
          <el-option :value="''" label="全部"/>
          <el-option :value="0" label="可发货"/>
          <el-option :value="1" label="处理中"/>
          <el-option :value="2" label="已出单"/>
          <el-option :value="3" label="已完成"/>
          <el-option :value="4" label="撤销"/>
        </el-select>
      </div>
      <div class="build-form-item">
        <span class="build-form-key">选择标旗</span>
          <el-select  v-model="order_param.remark_tag" @change="onSelectFilter"
                   style="width: 300px;">
          <el-option :value="''" label="全部"/>
          <el-option :value="0" label="灰棋"/>
          <el-option :value="1" label="红旗"/>
          <el-option :value="2" label="黄旗"/>
          <el-option :value="3" label="绿旗"/>
          <el-option :value="4" label="蓝旗"/>
          <el-option :value="5" label="紫旗"/>
          <el-option :value="6" label="青旗"/>
          <el-option :value="7" label="橙旗"/>
        </el-select>
      </div>
      <div class="build-form-item">
        <div style="flex: 1">
          <el-input
              type="textarea"
              :autosize="{ minRows: 4}"
              placeholder="订单筛选"
              v-model="order_param.tids">
          </el-input>
          <p class="filter-tips">注意：一行一条单号，同步订单后才能进行订单筛选，同步订单点击刷新订单</p>
        </div>
        <div style="flex: 1">
          <div style="width:200px;margin: 0 0 0 20px;">
            <el-input
                type="text"
                placeholder="开始时间"
                v-model="order_param.startTime">
            </el-input>
          </div>
          <div style="width:200px;margin:20px;">
            <el-input
                type="text"
                placeholder="结束时间"
                v-model="order_param.endTime">
            </el-input>
          </div>
        </div>
      </div>

    </div>

    <div class="address-table-main">
      <div class="shop-button">
        <a href="javascript:void(0)" class="btn btn_1" @click="onRemoteOrder">刷新订单</a>
        <a href="javascript:void(0)" class="btn btn_1" @click="onLocationOrder">查询订单</a>
      </div>

      <div class="order-list">
        <el-table
            v-loading="selectShopOrderloading"
            :data="order_list"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;"
            @selection-change="selectionShopOrderChangeHandle"
            ref="orderTable">
          <el-table-column
              type="selection"
              width="50"
              align="center"
              fixed="left"/>

          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.status === 0 ? '可发货' : scope.row.status === 1 ? '处理中' : scope.row.status === 2 ? '已出单' : scope.row.status === 3 ? '已完成' : '已退款'
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="旗色" align="center">
            <template slot-scope="scope">
              <span class="order-item-val">{{ scope.row.remark_tag }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单编号" align="center" width="180">
            <template slot-scope="scope">
              <span class="order-item-val">{{ scope.row.tid }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品信息" width="200">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="product-info-right">
                  <p class="product-name">{{ scope.row.goods_name }}</p>
                  <!--                  <p class="product-order-on">ID：{{ scope.row.order_no }}</p>-->
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="价格" align="center">
            <template slot-scope="scope">
              <span class="order-item-val">{{ scope.row.goods_price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <span class="order-item-val">{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付时间" align="center" width="180">
            <template slot-scope="scope">
              <span class="order-item-val">{{ scope.row.createtime | timeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收件人信息" align="center">
            <template slot-scope="scope">
              <span class="order-item-val">{{ scope.row.receiver_address}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <el-checkbox class="selectAll" type="selection" @change="selectAll">全选</el-checkbox>
          <el-pagination
              :current-page="order_param.page"
              :page-sizes="[10, 20, 50, 100, 300, 500]"
              :page-size="order_param.limit"
              :total="totalOrder"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"/>
        </div>
      </div>
    </div>

    <el-dialog
        :visible.sync="dialogShopVisible"
        :before-close="handleShopClose"
        title="添加店铺"
        width="700px">
      <div class="build-shop-list">
        <div class="build-shop-item"
             v-for="(item, index) in build_shop_list"
             :key="index" v-if="openSendShop[item.open_key] > 0">
          <a href="javascript:void(0)" class="shop-item-center" @click="onJumpBuild(item)">
            <img class="platform-icon" :src="`${IMG_URL}images/order/${item.icon}.png`" alt="">
            <div class="shop-item-right">
              <p class="platform-name">{{item.platform}}</p>
              <p class="server-name">{{item.name}}</p>
            </div>
          </a>
          <a v-if="item.link" :href="item.link" target="_blank" class="server-link">订购服务</a>
          <!-- <a v-if="item.name == '悦己打单'" :href="IMG_URL+'images/yjhelp.jpg'" target="_blank" class="server-link">查看教程</a> -->
          <a v-if="item.name == '悦己打单'" href="https://fuwu.taobao.com/ser/order/biz_order_list.htm" target="_blank" class="server-link">申请退款</a>
          <a v-if="item.key === 'DyAcs'" :href="build_info.DyAcsSd" target="_blank" class="build-link">若拉取不到订单，点击这里店铺授权</a>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleShopClose">取 消</el-button>
      </span>
    </el-dialog>


    <el-dialog
        :visible.sync="dialogVisible2"
        :close-on-click-modal="false"
        :before-close="handleClose2"
        width="350px">
      <div slot="title" class="dialog-top">
        请输入{{ build_type === "DyAcs" ? '闪电店铺邀请码 例如:yihsuo17' : build_type === "KsAcs" ? '人人快打店铺邀请码 例如:IKMV0XNZUXDXXXX' : build_type === 'TbAcsNb' ? '旺旺昵称 例如：xx旗舰店' : build_type === 'TbAcsYj' || build_type === 'TbAcsKd' || build_type === 'TbAcsWd'|| build_type === 'TbAcsYd' ? '店铺昵称 例如：xx旗舰店' : build_type === 'DyAcsYt' ? '店铺昵称 例如：xx旗舰店' :  (build_type === 'JdAcsYt' || build_type === 'JdAcsYd') ? "店铺名称" : '拼多多账号 例如：pdd86102981234'
        }}
      </div>
      <div>
        <el-input v-model="shop_code" type="text"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose2">取 消</el-button>
        <el-button @click="onBuildShop">确 定</el-button>
      </span>
    </el-dialog>

    <div class="red">
      <h2>云兔打单 支持自动发货的仓库:</h2>
      <p class="yt_ck">{{yt_ck}}</p>
      <!-- <h2>蜗牛打单 支持自动发货的仓库:</h2>
      <p class="yt_ck">{{wn_ck}}</p> -->
    </div>
  </div>
</template>

<script>

import {
  apiShopRemoteOrder,
  apiShopLocationOrder,
  apiShopDyBuild,
  apiShopWnBuild,
  apiShopBuild,
  apiShopDelete,
  apiGetYtCk,
} from '@/api/api'
import axios from 'axios';
import {getToken} from "@/api/auth"

export default {
  name: "mode3",
  props: {
    shopList: {
      type: Array,
      default: function (data) {
        return data || []
      }
    },
    openSendShop: {
      type: Object,
      default: function (data) {
        return data || {}
      }
    },
    sourceId: {
      type: Number,
      default: 0,
    },
    platform: {
      type: String,
      default: 'TbAcs',
    },
    modeName: {
      type: String,
      default: '自动发货',
    }
  },
  data() {
    return {
      yjHelp: "/images/yjhelp.jpg",
      yjHelpList: ["/images/yjhelp.jpg"],
      yt_ck: "",
      wn_ck: "",
      build_type: "",
      shop_code: "",
      dialogVisible2: false,
      dialogShopVisible: false,
      totalOrder: 0,
      selectShopOrderloading: false,
      order_list: [],
      build_info: {},
      build_shop_list: [
        {
          platform: '淘宝',
          icon: "tb-icon",
          name: "快打打单",
          key: "TbAcsKd",
          open_key: 'open_yueji',
          link: "https://fuwu.taobao.com/ser/detail.htm?service_code=ts-26066"
        },
        {
          platform: '淘宝',
          icon: "tb-icon",
          name: "旺店管家",
          key: "TbAcsWd",
          open_key: 'open_yueji',
          link: "https://fuwu.taobao.com/ser/detail.htm?service_code=FW_GOODS-1000360715"
        },
        {
          platform: '淘宝',
          icon: "tb-icon",
          name: "益店打单(推荐)",
          key: "TbAcsYd",
          open_key: 'open_yueji',
          link: "https://fuwu.taobao.com/ser/detail.htm?service_code=FW_GOODS-1000869937"
        },
        {
          platform: '淘宝',
          icon: "tb-icon",
          name: "悦己打单",
          key: "TbAcsYj",
          open_key: 'open_yueji',
          link: "https://fuwu.taobao.com/ser/detail.htm?service_code=ts-15319"
        },
        {
          platform: '淘宝',
          icon: "tb-icon",
          name: "易通打单(已冻结)",
          key: "TbAcsYt",
          open_key: 'open_yitong',
          link: "https://fuwu.taobao.com/ser/detail.htm?service_code=ts-21954&spm=a1z13.1113647.0.0.528e5acaTr6kjr&code=ts-21954"
        },
        // {platform: '淘宝',
        //   icon: "tb-icon",
        //   name: "飞快打印(推荐)",
        //   open_key: 'open_nbdd',
        //   key: "TbAcsNb",
        //   link: "https://c.tb.cn/Y4.f3uJQ"
        // },
        // {
        //   platform: '淘宝',
        //   icon: "tb-icon",
        //   name: "智能发货(推荐)",
        //   key: "TbAcsFc",
        //   open_key: 'open_znfh',
        //   link: "https://fuwu.taobao.com/ser/detail.htm?service_code=ts-24066"
        // },
        {
          platform: '拼多多',
          icon: "pdd-icon",
          name: "蜗牛打单(广州邮政专用)",
          key: "PddAcs",
          open_key: 'open_wndd',
          link: "https://fuwu.pinduoduo.com/service-market/service-detail?detailId=777"
        },
        {
          platform: '拼多多',
          icon: "pdd-icon",
          name: "云兔打单",
          key: "PddAcsYt",
          open_key: 'open_yuntu',
          link: "https://fuwu.pinduoduo.com/service-market/service-detail?detailId=46171"
        },
        {
          platform: '京东',
          icon: "jd-icon",
          name: "闪电",
          key: "JdAcs",
          open_key: 'open_jdsd',
          link: "https://fw.jd.com/main/detail/FW_GOODS-530004"
        },
        // {
        //   platform: '京东',
        //   icon: "jd-icon",
        //   name: "易通打单",
        //   key: "JdAcsYt",
        //   open_key: 'open_yueji',
        //   link: "http://tbnew.ybdsoft.com/buy_soft?platform=jd"
        // },
        {
          platform: '京东',
          icon: "jd-icon",
          name: "益店打单",
          key: "JdAcsYd",
          open_key: 'open_yueji',
          link: "http://jd.yidiansoftware.com/subscribe"
        },
        {
          platform: '抖音',
          icon: "dy-icon",
          name: "订单宝",
          key: "DyAcsYt",
          open_key: 'open_yueji',
          link: "http://dy.wanxiangwuliu.cn/api/auth/jump?state=zNXMZc6q48JIkhuj"
        },
        {
          platform: '抖音',
          icon: "dy-icon",
          name: "闪电打单",
          key: "DyAcs",
          open_key: 'open_sdkd',
          link: "https://fuwu.jinritemai.com/detail?from=fuwu_market_tab&service_id=33"
        },
        {
          platform: '快手',
          icon: "ks-icon",
          name: "人人快打",
          key: "KsAcs",
          link: "",
          open_key: 'open_rrkd',
        },
      ],
      order_param: {
        shop_id: '',
        tids: '',
        shop_type: '',
        platform: '',
        limit: 10,
        page: 1,
        status: '',
        remark_tag: ''
      }
    }
  },
  watch: {
    shopList: {
      handler(nVal, oVal) {
        if (nVal.length > 0 && this.modeName === '自动发货') {
          const row = nVal[0];
          this.order_param.shop_id = row.shop_id;
          this.order_param.shop_type = row.shop_type;
          this.$emit("onSelectShop", this.order_param);
        }
      },
      immediate: true,
      deep: true
    }
  },
  filters: {
    timeFilter(time) {
      if (!time) return '—'
      let date = new Date(time * 1000)
      let y = date.getFullYear()
      let m = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
      let d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      let hh = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      let mm = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      let ss = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    }
  },
  mounted() {
    this.getShopBuild();
    let that = this;
    axios.get("/yt_ck").then(function(res){
      that.yt_ck = res['data'];
    });
    axios.get("/wn_ck").then(function(res){
      that.wn_ck = res['data'];
    });
  },
  methods: {
    loadShopData() {
      this.$emit("buildOk")
    },
    //删除店铺
    onDeleteShop() {
      var shop_id = 0;
      for (let i = 0; i < this.shopList.length; i++) {
        if (this.order_param.shop_id == this.shopList[i].shop_id) {
          shop_id = this.shopList[i].id;
        }
      }
      var that = this
      this.$confirm('是否确定解绑该店铺？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiShopDelete({id: shop_id}).then(res => {
          if (res.code === 1) {
            that.$message.success('解绑成功');
            this.order_param = {
              shop_id: '',
              tids: '',
              shop_type: '',
              platform: this.platform,
              limit: 20,
              page: 1,
              status: '',
              remark_tag: ''
            }
            this.$emit("buildOk");
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    onBuildShop() {
      var par_key = this.build_type === 'DyAcs' || this.build_type === 'KsAcs' ? 'invite_code' : this.build_type === 'TbAcsNb' ? 'sell_nick' : 'ownerName'
      var param = {}
      param[par_key] = this.shop_code
      var URL = "";
      if(this.build_type === 'DyAcs'){
        URL = 'api/shop/dy_bindShop';
      }else if(this.build_type === 'KsAcs'){
        URL = 'api/shop/ks_bindShop';
      }else if(this.build_type === 'PddAcs'){
        URL = 'api/shop/wn_bindShop';
      }else if(this.build_type === 'PddAcsYt'){
        URL = 'api/shop/yuntu_bindShop';
      }else if(this.build_type === 'TbAcsYj'){
        URL = 'api/shop/bl_bindShop';
        param['type'] = 'tb_yj';
      }else if(this.build_type === 'TbAcsKd'){
        URL = 'api/shop/bl_bindShop';
        param['type'] = 'tb_kd';
      }else if(this.build_type === 'TbAcsWd'){
        URL = 'api/shop/bl_bindShop';
        param['type'] = 'tb_wd';
      }else if(this.build_type === 'TbAcsYd'){
        URL = 'api/shop/bl_bindShop';
        param['type'] = 'tb_yd';
      }else if(this.build_type === 'DyAcsYt'){
        URL = 'api/shop/bl_bindShop';
        param['type'] = 'dy_yt';
      }else if(this.build_type === 'JdAcsYt'){
        URL = 'api/shop/bl_bindShop';
        param['type'] = 'jd_yt';
      }else if(this.build_type === 'JdAcsYd'){
        URL = 'api/shop/bl_bindShop';
        param['type'] = 'jd_yd';
      }else{
        URL = 'api/shop/nb_bindShop';
      }
      // this.API_URL = "http://df.daifabashi.cn/"
      // console.log(this.build_type);
      axios.get(this.API_URL + URL, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'header-token': getToken()
        },
        params: param
      }).then(res => {
        if (res.data.code === 1) {
          // 
          this.dialogVisible2 = false
          this.shop_code = ''
          var source = 0;
          if (this.build_type.indexOf('TbAcs') !== -1) {
            source = 0;
          } else if (this.build_type.indexOf('JdAcs') !== -1) {
            source = 1;
          } else if (this.build_type.indexOf('DyAcs') !== -1) {
            source = 4;
          } else if (this.build_type.indexOf('KsAcs') !== -1) {
            source = 5;
          } else if (this.build_type.indexOf('PddAcs') !== -1) {
            source = 2;
          }
          if(res.data.msg == '绑定成功'){
            this.$message.success('绑定成功');
          }
          if(res.data.msg=="请绑定"){
            window.open(res.data.data.url);
          }else{
            this.$emit("buildOk", source)
          }
        } else {
          if(res.data.data && res.data.data.url){
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.open(res.data.data.url);
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
          }else{
            this.$message.error(res.data.msg);
          }
          return false
        }
      })
    },

    handleClose2() {
      this.dialogVisible2 = false;
    },
    getShopBuild() {
      this.build_info = {};
      return;
      
      apiShopBuild({
        url: '/api/shop/bind_api_url',
        return_url: this.API_URL + '#/order/add',
        callback_url: this.API_URL + 'index/notify/open_authorize_callback/user_id/' + this.$store.getters.user.id
      }).then(res => {
        this.build_info = res.data;
        if (this.build_info == null) {
          this.build_info = {};
        }
      })
    },
    onJumpBuild(row) {
      // console.log(row);
      if (this.build_info[row.key]) {
        window.open(this.build_info[row.key]);
      }
      // else if(row.key == 'TbAcsKd'){
      //   this.onBuildShop();
      // }
       else {
        this.shop_code = "";
        this.build_type = row.key;
        this.dialogShopVisible = false;
        this.dialogVisible2 = true;
      }
    },
    handleShopClose() {
      this.dialogShopVisible = false;
    },
    addBuildShop() {
      this.dialogShopVisible = true;
    },
    onSelectFilter() {
      this.order_param.page = 1;
      this.onLocationOrder()
    },
    // 选择店铺
    onSelectShop() {
      this.selectShopOrderloading = true
      for (var i = 0; i < this.shopList.length; i++) {
        if (this.order_param.shop_id == this.shopList[i].shop_id) {
          if (this.shopList[i].shop_type) {
            this.order_param.shop_type = this.shopList[i].shop_type
          }
        }
      }
      this.$emit("onSelectShop", this.order_param);
      this.onLocationOrder()
    },
    onRemoteOrder() {
      const param = {
        shop_id: this.order_param.shop_id,
        shop_type: this.order_param.shop_type,
        platform: this.platform,
        tids: this.order_param.tids,
        remark_tag: this.order_param.remark_tag,
        startTime: this.order_param.startTime,
        endTime: this.order_param.endTime
      }
      apiShopRemoteOrder(param).then(res => {
        if (res.code === 1) {
          this.$message.info(res.msg);
          this.onLocationOrder();
          setTimeout(() => {
            this.onLocationOrder();
          }, 5000)
        } else {
          this.selectShopOrderloading = false
        }
      })
    },
    onLocationOrder() {
      var param = {
        shop_id: this.order_param.shop_id,
        limit: this.order_param.limit,
        page: this.order_param.page,
        status: this.order_param.status,
        tids: this.order_param.tids,
        remark_tag: this.order_param.remark_tag,
        remark_tag_name: '',
        remark: '',
        order_nos: '',
        startTime: '',
        endTime: '',
        startPrice: '',
        endPrice: '',
        platform: this.platform
      }
      this.$emit("onSelectShop", param);
      apiShopLocationOrder(param).then(res => {
        if (res.code === 1) {
          this.order_list = res.data.rows
          this.totalOrder = res.data.total
          this.selectShopOrderloading = false
        } else {
          // this.$message.error(res.msg)
          this.selectShopOrderloading = false
        }
      })
    },
    handleCurrentChange(val) {
      this.order_param.page = val;
      this.onLocationOrder();
    },
    handleSizeChange(val) {
      this.order_param.limit = val;
      this.onLocationOrder();
    },
    selectionShopOrderChangeHandle(val) {
      this.$emit("onSelectOrder", val)
    },
    selectAll(){
      this.$refs.orderTable.toggleAllSelection();
    },
  }
}
</script>

<style scoped lang="scss">

.selectAll{
  float: left;
  position: relative;
  top: 10px;
  left: 20px;
}
.mode3 {

  .red{
    color: red;
  }
  .yt_ck{
    font-size: 16px;
    font-weight: bold;
    color: blue;
  }

  .explain-box {
    margin-bottom: 30px;

    p {
      margin: 0 0 10px;
      color: #878787;
    }
  }

  .build-shop {

    .build-form-item {
      margin-bottom: 15px;
      display: flex;
      align-items: center;

      .filter-tips {
        margin: 5px 0;
        color: #FF0000;
        font-size: 12px;
      }

      .build-form-key {
        color: #000000;
        margin-right: 10px;
      }

      .build-form-item-content {
        display: flex;
        align-items: center;
        margin-right: 15px;
      }
    }
  }

  .shop-button {
    display: flex;
    align-items: center;

    .btn {
      margin-right: 15px;
      width: 100px;
      height: 30px;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
    }

    .btn_1 {
      background-color: #0f375a;
      color: #ffffff;
    }

    .btn_2 {
      border: 1px solid #0f375a;
      color: #0f375a;
    }
  }

  .order-list {
    margin-top: 10px;
  }

  .build-shop-list {
    display: flex;
    flex-wrap: wrap;

    .build-shop-item {
      margin: 0 12px 20px;

      .shop-item-center {
        width: 140px;
        height: 50px;
        border: 1px solid #E6E6E6;
        display: flex;
        align-items: center;
        justify-content: center;

        .shop-item-right {
          font-size: 12px;
          margin-left: 8px;
        }
      }

      .server-link {
        display: block;
        text-align: center;
        color: #127AF7;
        font-weight: bold;
        font-size: 12px;
        margin-top: 5px;
      }
      .server-link {
        display: block;
        text-align: center;
        color: #127AF7;
        font-weight: bold;
        font-size: 12px;
        margin-top: 5px;
      }

      p {
        margin: 0;
        font-weight: bold;
        color: #0f375a;
      }

      .platform-icon {
        width: 32px;
        height: 32px;
        border-radius: 8px;
      }
    }
  }
}

.dialog-top {
  color: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/order/components/mode/mode_3.vue